import axios from 'axios'
import BaseRequest from './BaseRequest'

export default class BikkuraponRequest extends BaseRequest {
  getSettings() {
    return axios.get(`${this.baseUrl}/admin/bikkurapon/settings`)
  }

  update(params) {
    return axios.post(
      `${this.baseUrl}/admin/bikkurapon/settings/update`,
      params
    )
  }
}
